module.exports = __webpack_public_path__ + "img/여가산업.61b0916a.png";